var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
                    name: 'themes-slug',
                    params: {
                        slug: _vm.$t('labels.sea_theme_button').toLowerCase(),
                        theme: 'MilService_tab/Sea/'}}}},[_vm._v(" "+_vm._s(_vm.$t('labels.sea_theme_button'))+" ")]),_c('router-link',{attrs:{"to":{
                    name: 'themes-slug',
                    params: {
                        slug:  _vm.$t('labels.land_theme_button').toLowerCase(),
                        theme: 'MilService_tab/Land/'}}}},[_vm._v(" "+_vm._s(_vm.$t('labels.land_theme_button')))]),_c('router-link',{attrs:{"to":{
                    name: 'themes-slug',
                    params: {
                        slug:  _vm.$t('labels.air_theme_button').toLowerCase(),
                        theme: 'MilService_tab/air/'}}}},[_vm._v(" "+_vm._s(_vm.$t('labels.air_theme_button')))]),_c('router-link',{attrs:{"to":{
                     name: 'themes-slug',
                     params: {
                         slug:  _vm.$t('labels.women_theme_button').toLowerCase(),
                         theme: 'NamSex/Female/'}}}},[_vm._v(" "+_vm._s(_vm.$t('labels.women_theme_button')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }